module.exports = __webpack_public_path__ + "files/c3708e3098bfa9ac7690ce92dffafdd0.png";